var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicroscope = function SvgMicroscope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "microscope_svg__a",
    width: "105.8%",
    height: "102%",
    x: "-2.9%",
    y: "-.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "microscope_svg__b",
    d: "M0 0h800v2358H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-624-288H816v2626H-624z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -84)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#microscope_svg__b",
    fill: "#000",
    filter: "url(#microscope_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#microscope_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M5.5 24a.5.5 0 1 1 0-1H11v-1c-2.886 0-4.976-1.069-6.342-2.115l-.174-.136c-.415-.323-.673-.565-.816-.75L1.5 19a.5.5 0 1 1 0-1h7a.5.5 0 1 1 0 1H5.234c.223.178.416.343.533.422 1.156.776 2.891 1.575 5.233 1.575 4.296 0 9.18-3.316 9.495-9.183.05-1.46-.279-2.772-.645-3.745l-7.486 7.487a1 1 0 0 1-1.327.078l-.087-.078-.707.707a1 1 0 0 1-1.415 0L7.414 14.85a1 1 0 0 1 0-1.414l.707-.707a1 1 0 0 1 0-1.414L18.728.707a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L20.638 7.28c.467 1.05.907 2.541.849 4.533-.135 5.874-4.703 9.668-9.487 10.137v1.048l5.5.001a.5.5 0 1 1 0 1zm3.328-10.565-.707.707 1.415 1.414.706-.706zm10.607-12.02L8.828 12.02l2.829 2.828L22.263 4.243z"
  }))));
};
export default SvgMicroscope;